import { ScopeItem } from '../components/form-fields/scope-selector/scope-selector-constants';
import { ScopeableType } from '../types';

interface PackageOfferingForScope {
  packageOffering: string;
  programIndication?: string | null;
}

interface ProductOfferingForScope {
  id: number;
  name: string;
}

// A ProductOffering scope matches a contract package when the package's
// program_indication rows include a string equal to the ProductOffering's name.
// (Yes, the join is by name string — that's the contract for now.)
export const getProductOfferingIdsForPackage = (
  packageOfferings: PackageOfferingForScope[],
  productOfferings: ProductOfferingForScope[],
): Set<number> => {
  const indications = new Set(
    packageOfferings
      .filter(
        po =>
          po.packageOffering === 'program_indication' && !!po.programIndication,
      )
      .map(po => po.programIndication as string),
  );
  return new Set(
    productOfferings.filter(po => indications.has(po.name)).map(po => po.id),
  );
};

export const normalizeScopes = (scopes?: ScopeItem[] | null): ScopeItem[] => {
  if (scopes && scopes.length > 0) return scopes;
  return [{ scopeableType: ScopeableType.Global, scopeableId: null }];
};

// Bridges scopes back to the legacy single-package shape for the surfaces that
// still drive their forms/displays by packageId (VBD form, program-cap credits).
// A Package scope yields its id; a Global scope yields 0 ("All Packages"); any
// other shape yields null.
export const packageIdFromScopes = (
  scopes?: ScopeItem[] | null,
): number | null => {
  const packageScope = (scopes ?? []).find(
    s => s.scopeableType === ScopeableType.Package,
  );
  if (packageScope) return packageScope.scopeableId ?? null;
  if ((scopes ?? []).some(s => s.scopeableType === ScopeableType.Global)) {
    return 0;
  }
  return null;
};
